module.exports = __webpack_public_path__ + "static/media/beaconManageJobsHeader.62e21ac5.jpg";